export default __webpack_public_path__ + "static/media/team73.a914f5e2.JPG";